/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PRESENTATIONS } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IPresentationsMethods extends IPluginMethodMap {
  getPresentationsProps(): Promise<any>;
}

export class PresentationsService implements IAgentPlugin {
  readonly methods: IPresentationsMethods;

  constructor() {
    this.methods = {
      getPresentationsProps: this.getPresentationsProps.bind(this),
    };
  }

  async getPresentationsProps() {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        // const res = await client.query({
        //   query: GET_PRESENTATIONS,
        //   variables: {
        //     filter: {},
        //   },
        //   fetchPolicy: "network-only",
        // });

        // if (res?.data) {
        //   return {
        //     presentationsFilter: res?.data?.getPresentations?.content?.map(
        //       (_item: any) => {
        //         return { value: _item?.id, label: _item?.name };
        //       }
        //     ),
        //     defaultPresentations: res?.data?.getPresentations?.content.find(
        //       (item: any) => item.status === "active"
        //     )?.id,
        //     response: res?.data?.getPresentations?.content,
        //   };
        // }
        return {
          presentationsFilter: [
            { value: "TR01", label: "TRIBE FRONT TRUCK" },
            { value: "TR02", label: "TRIBE BACK TRUCK" },
            { value: "HS01", label: "HARTS FRONT TRUCK" },
            { value: "HS02", label: "HARTS BACK TRUCK" },
            { value: "LT01", label: "LOST TRIBE FRONT TRUCK" },
            { value: "LT02", label: "LOST TRIBE BACK TRUCK" },
            { value: "BL01", label: "BLISS FRONT TRUCK" },
            { value: "BL02", label: "BLISS BACK TRUCK" },
          ],
          defaultPresentations: "TR01",
        };
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
